class HeroVideoControl extends HTMLElement {
    /**
     * @type {Element | null}
     */
    iconPlay = null;
    /**
     * @type {Element | null}
     */
    iconPause = null;

    connectedCallback() {
        const container = this.closest('[data-js-hero-container]');
        if (!container) return;

        const video = container.querySelector('video');
        const button = this.querySelector('[data-js-button]');
        if (!video || !button) return;

        this.iconPlay = button.querySelector('[data-js-icon-play]');
        this.iconPause = button.querySelector('[data-js-icon-pause]');

        button.addEventListener('click', () => {
            this.togglePlayPause(video);
        });
    }

    /**
     * @param {HTMLVideoElement} video
     */
    togglePlayPause(video) {
        if (video.paused) {
            video.play().then(() => {
                if (this.iconPlay && this.iconPause) {
                    this.iconPlay.classList.add('play-pause-button__icon--hidden');
                    this.iconPause.classList.remove('play-pause-button__icon--hidden');
                }
            }).catch((error) => {
                console.error('Video playback failed:', error);
            });
        } else {
            video.pause();
            if (this.iconPlay && this.iconPause) {
                this.iconPlay.classList.remove('play-pause-button__icon--hidden');
                this.iconPause.classList.add('play-pause-button__icon--hidden');
            }
        }
    }
}

if (!customElements.get('hero-video-control')) {
    customElements.define('hero-video-control', HeroVideoControl);
}
